import { useQuery } from '@tanstack/react-query';
import { graphqlFetch } from '../../lib/graphql-fetch';
import { LIST_RECENT_NOTABLE_PULLS_QUERY } from '../../lib/graphql-queries';

/**
 * Social / recent-pulls TanStack Query hooks.
 *
 * `useListRecentNotablePulls` — public (apiKey), shows high-value recent pulls
 * as social proof on the browse page.
 *
 * Lever H (Round 3.5): uses the lightweight graphqlFetch helper. The
 * OLD code used `(client.queries as any).listRecentNotablePulls(...)`
 * with a cast because the custom resolver isn't in the typed Schema;
 * the helper has no such typing constraint and the cast is gone.
 */

export interface NotablePull {
  card_name: string;
  card_image_url: string;
  card_image_url_thumb?: string | null;
  card_image_url_2x?: string | null;
  card_rarity: string;
  market_price_cents: number;
  created_at: string;
  puller_initials?: string | null;
  pack_id?: string | null;
}

async function fetchRecentNotablePulls(): Promise<NotablePull[]> {
  const data = await graphqlFetch<{ listRecentNotablePulls: (NotablePull | null)[] }>(
    LIST_RECENT_NOTABLE_PULLS_QUERY,
  );
  return (data.listRecentNotablePulls ?? []).filter((p): p is NotablePull => p !== null);
}

export function useListRecentNotablePulls() {
  return useQuery({
    queryKey: ['social', 'recent-notable-pulls'] as const,
    queryFn: fetchRecentNotablePulls,
    staleTime: 60_000,
    refetchInterval: 15_000,
  });
}
